import { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Button, TextField, Typography, Container, Box, CssBaseline, Avatar } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next'; // Import for internationalization

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(); // Hook for translation

  const handleReset = async () => {
    setLoading(true);
    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(t("password_reset_email_sent"));
    } catch (error) {
      setMessage(t(error.message) || t("password_reset_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t("reset_password")}
        </Typography>
        <Box component="form" noValidate sx={{ mt: 3 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={t("email_address")}
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {message && (
            <Typography variant="body2" color={message.includes("sent") ? "green" : "error"} sx={{ mt: 2 }}>
              {message}
            </Typography>
          )}
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleReset}
            disabled={loading}
          >
            {loading ? t("sending") : t("send_reset_email")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
